export const COMPANY_TABS = {
  OVERVIEW: 'OVERVIEW',
  NEWS: 'NEWS',
  TEAM: 'TEAM',
  INVESTORS: 'INVESTORS',
  FINANCIALS: 'FINANCIALS',
  PROJECTS: 'PROJECTS',
} as const;

export type CompanyTab = keyof typeof COMPANY_TABS;
